// extracted by mini-css-extract-plugin
module.exports = {"deltaProKit":"deltaProKit_deltaProKit__G0TF6"};